<template>
  <div>
    <naj-modal
      ref="attachmentModal"
      :title="local.attachments.addAttachment"
      :button-text="modalButtonText"
      :width="1200"
      :footer="true"
      :show-footer-close-button="true"
      :persistent="!previewMode"
      @onClose="resetModalData"
      @input="inputEventHandler"
    >
      <view-attachment
        v-if="previewMode && attachment"
        :attachment="attachment"
        :is-image="isImage"
        @showFullScreen="showFullScreen"
      ></view-attachment>
      <add-attachment
        v-else
        ref="addAttachmentForm"
        :form-model="formModel"
        :is-image="isImage"
        :attachment-categories="attachmentCategories"
        :loading="loading"
        :preview-mode="previewMode"
        :accept="accept"
        :max-file-size="maxFileSize"
        :attachment-type-disabled="attachmentTypeDisabled"
        @showFullScreen="showFullScreen"
        @fileSelected="fileSelected"
      ></add-attachment>
      <template slot="actions">
        <naj-button
          v-if="!previewMode"
          type="submit"
          :loading="submitLoading"
          @click="saveImage"
        >
          {{ actionText || local.common.addToCase }}
        </naj-button>

        <div
          v-if="false && previewMode && attachmentsLength > 1"
          class="modal-actions text-center"
        >
          <naj-button
            :disabled="isLastAttachmentInList"
            @click="nextAttachment"
          >
            {{ local.common.next }}
          </naj-button>
          <naj-button
            :disabled="isFirstAttachmentInList"
            @click="prevAttachment"
          >
            {{ local.common.previous }}
          </naj-button>
        </div>
      </template>
    </naj-modal>

    <full-screen-attachment
      :attachment="previewMode ? attachment : formModel"
      :visibility="isFullScreen"
      :is-image="isImage"
      @onClose="hideFullScreen"
    ></full-screen-attachment>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');

import AddAttachment from './add-attachment';
import ViewAttachment from './view-attachment';
import FullScreenAttachment from './full-screen-attachment';
import { attachmentType } from '@/helpers/enum';
// import { local } from '@/local/index.js';
// console.log(local);
const initForm = () => ({
  name: null,
  fileType: null,
  category: null,
  fileUrl: null,
  fileObject: null,
});
export default {
  name: 'AttachmentModal',
  components: {
    AddAttachment,
    ViewAttachment,
    FullScreenAttachment,
  },
  props: {
    attachment: {
      type: Object,
      required: false,
      validator(value) {
        const requiredProperties = ['fileUrl', 'name', 'fileType', 'attachmentKey'];
        return requiredProperties.every(prop => Object.prototype.hasOwnProperty.call(value, prop));
      },
    },
    accept: { type: String },
    maxFileSize: { type: Number },
    viewMode: {
      type: Boolean,
      default: false,
    },
    attachmentsData: {
      type: Array,
      required: false,
      default: () => [],
    },
    attachmentCategories: {
      type: Array,
      required: false,
      default: () => [],
    },
    submitLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    modalButtonText: {
      type: String,
      required: false,
      default: '',
    },
    actionText: {
      type: String,
      required: false,
      default: '',
    },
    attachmentTypeDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      reader: new FileReader(),
      loading: false,
      isFullScreen: false,
      attachmentKey: null,
      formModel: initForm(),
    };
  },
  computed: {
    isImage() {
      return (
        // eslint-disable-next-line eqeqeq
        ((this.attachment && this.attachment.fileType) || this.formModel.fileType) ==
        attachmentType.image
      );
    },
    previewMode() {
      return this.attachment && !!this.attachment.fileUrl;
    },
    currentAttachmentIndex() {
      return Object.keys(this.attachmentsData)
        .indexOf(this.attachment.attachmentKey);
    },
    attachmentsLength() {
      return Object.keys(this.attachmentsData).length;
    },
    isLastAttachmentInList() {
      // eslint-disable-next-line eqeqeq
      return this.currentAttachmentIndex == this.attachmentsLength - 1;
    },
    isFirstAttachmentInList() {
      // eslint-disable-next-line eqeqeq
      return this.currentAttachmentIndex == 0;
    },
    categoryName() {
      // eslint-disable-next-line eqeqeq
      const category = this.attachmentCategories.find(item => item.id == this.formModel.category);
      return category ? category.name : null;
    },
  },
  created() {
    this.reader.onload = (e) => {
      this.updateImageUrl(e.target.result);
    };
  },
  methods: {
    ...mapCasesActions(['getAttachment']),
    showFullScreen() {
      this.isFullScreen = true;
    },
    hideFullScreen() {
      this.isFullScreen = false;
    },
    readCurrentAttachmentURL(fileObject) {
      this.reader.abort(); // cancel the read operation if found
      this.reader.readAsDataURL(fileObject);
    },
    fileSelected(data) {
      const { fileUrl, fileType, category, name, fileObject, extension } = data.selectedAttachment;
      this.formModel = Object.assign({}, this.formModel, {
        fileUrl,
        fileType,
        category: Number(this.formModel.category) || category,
        name: name || this.formModel.name,
        fileObject,
        extension,
      });
      this.attachmentKey = data.selectedAttachmentKey;
      !this.formModel.fileUrl && this.readCurrentAttachmentURL(data.selectedAttachment.fileObject);
    },
    updateImageUrl(imageUrl) {
      this.formModel.fileUrl = imageUrl;
    },
    resetModalData() {
      this.formModel = initForm();
      this.$emit('onClose');
    },
    inputEventHandler() {
      this.attachmentTypeDisabled = false;
    },
    showModal(categoryId) {
      this.$refs.attachmentModal.show();

      if (categoryId) {
        this.formModel.category = categoryId;
      }
    },
    closeModal() {
      this.$refs.attachmentModal.close();
    },
    showAttachment(file) {
      this.showModal();

      this.getAttachment(file.sharepointId).then((data) => {
        this.formModel = {
          ...this.formModel,
          name: file.fileName,
          category: file.fileCategory,
          fileType: file.extension,
          fileUrl: `data:${file.extension};base64,${data.data}`,
        };
      });
    },
    isFileNameNotUnique(name) {
      // eslint-disable-next-line eqeqeq
      return !!this.attachmentsData.find(item => item.name == name.trim());
    },
    saveImage() {
      const { fileUrl, name, category, fileObject, fileType, extension } = this.formModel;

      if (this.isFileNameNotUnique(name)) {
        this.toaster.error(this.local.attachments.errors.nameNotUnique);
        return;
      }

      if (!fileUrl) {
        this.toaster.error(this.local.attachments.errors.attachment);
        return;
      }

      if (!category) {
        this.toaster.error(this.local.attachments.errors.category);
        return;
      }

      this.$refs.addAttachmentForm.validateForm()
        .then((valid) => {
          if (valid) {
            this.$emit('onSubmit', {
              attachmentKey: this.attachmentKey,
              attachment: {
                name,
                extension,
                category,
                categoryName: this.categoryName,
                fileUrl,
                fileObject,
                fileType,
              },
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.pdf-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  .pdf-viewer {
    height: inherit;
    display: block !important;
    text-align: center;
    ::v-deep canvas {
      width: auto !important;
      height: 100% !important;
    }
  }
}
.pdf-actions {
  position: absolute;
  bottom: 15px;
  left: 0;
  right: 0;
  text-align: center;
  .action {
    padding: 4px 8px 5px;
    margin-bottom: 0;
    .icon {
      font-size: 18px;
      font-weight: 600;
    }
  }
}
.modal-content {
  display: flex;
  padding: 30px 20px 20px;
  flex-direction: row;
  ::v-deep {
    > * {
      width: 50%;
    }
    .full-screen-button {
      position: absolute;
      top: 0;
      bottom: 55px;
      .pdf-file & {
        bottom: 75px;
      }
      right: 0;
      left: 0;
      z-index: 50;
      width: 30%;
      height: 80%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgba(255, 255, 255, 0.4);
      opacity: 0;
      transition: opacity 0.3s;
      margin: auto;
      .icon {
        background: #fff;
        width: 60px;
        height: 60px;
        border-radius: 50%;
      }
    }
    .attachment-edit-form {
      padding-left: 20px;
    }
    .loader-holder {
      min-height: 200px;
    }
    .loader-holder,
    .attachment-file-viewer {
      position: relative;
    }
    .attachment-file-viewer {
      max-height: 620px;
      &:hover {
        .full-screen-button {
          opacity: 1;
        }
      }
    }
    .attachment-info {
      font-size: 16px;
    }
  }
}
.modal-actions {
  direction: rtl;
  text-align: center;
  margin-top: 20px;
  padding-bottom: 20px;
}
.modal-card {
  width: 100%;
}
.or-text {
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  color: #252733;
  margin: 8px;
}
</style>
